var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_449_4233)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6 11.9C12.6 12.2864 12.2867 12.6 11.9 12.6H9.8C9.41333 12.6 9.1 12.2864 9.1 11.9V9.8C9.1 9.4136 9.41333 9.1 9.8 9.1H11.9C12.2867 9.1 12.6 9.4136 12.6 9.8V11.9ZM12.6 7.7H9.1C8.32667 7.7 7.7 8.3265 7.7 9.1V12.6C7.7 13.3735 8.32667 14 9.1 14H12.6C13.3733 14 14 13.3735 14 12.6V9.1C14 8.3265 13.3733 7.7 12.6 7.7ZM12.6 4.2C12.6 4.5864 12.2867 4.9 11.9 4.9H9.8C9.41333 4.9 9.1 4.5864 9.1 4.2V2.1C9.1 1.7136 9.41333 1.4 9.8 1.4H11.9C12.2867 1.4 12.6 1.7136 12.6 2.1V4.2ZM12.6 0H9.1C8.32667 0 7.7 0.6265 7.7 1.4V4.9C7.7 5.6735 8.32667 6.3 9.1 6.3H12.6C13.3733 6.3 14 5.6735 14 4.9V1.4C14 0.6265 13.3733 0 12.6 0ZM4.9 11.9C4.9 12.2864 4.58667 12.6 4.2 12.6H2.1C1.71333 12.6 1.4 12.2864 1.4 11.9V2.1C1.4 1.7136 1.71333 1.4 2.1 1.4H4.2C4.58667 1.4 4.9 1.7136 4.9 2.1V11.9ZM4.9 0H1.4C0.626667 0 0 0.6265 0 1.4V12.6C0 13.3735 0.626667 14 1.4 14H4.9C5.67333 14 6.3 13.3735 6.3 12.6V1.4C6.3 0.6265 5.67333 0 4.9 0Z",
    fill: "#024773"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_449_4233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery2);
export default __webpack_public_path__ + "static/media/Gallery2.e9457f816816e39591e743381fece714.svg";
export { ForwardRef as ReactComponent };